import { render, staticRenderFns } from "./pixels.vue?vue&type=template&id=60be6f62&scoped=true&"
import script from "./pixels.vue?vue&type=script&lang=js&"
export * from "./pixels.vue?vue&type=script&lang=js&"
import style0 from "./pixels.vue?vue&type=style&index=0&id=60be6f62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be6f62",
  null
  
)

export default component.exports